import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import type { Environment } from '../types/environment';

export default function EnvironmentsPage() {
    const [envs, setEnvs] = useState<Environment[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function load() {
            try {
                const resp = await fetch(`/api/environments`);
                if (resp.ok) {
                    const data = await resp.json();
                    setEnvs(Array.isArray(data) ? data : []);
                }
            } catch (err) {
                console.error('ListEnvironments error', err);
            }
        }
        load();
    }, []);

    return (
        <div style={{ paddingTop: '60px', maxWidth: '1024px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h1>Environments</h1>
                <Link to="/environments/new">
                    <button>Create environment</button>
                </Link>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Name</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Repos</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Created By</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Created At</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Updated By</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Updated At</th>
                    </tr>
                </thead>
                <tbody>
                    {envs.map((env) => (
                        <tr
                            key={env.EnvironmentID}
                            onClick={() => navigate(`/environments/${env.EnvironmentID}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{env.Name}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                                {env.Repos
                                    .map((r) => {
                                        const repo = r.Repo.startsWith(`${r.Org}/`) ? r.Repo.slice(r.Org.length + 1) : r.Repo;
                                        return `${r.Org}/${repo}`;
                                    })
                                    .join(', ')}
                            </td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{env.CreatedBy}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{new Date(env.CreatedAt).toLocaleString()}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{env.UpdatedBy || '-'}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{env.UpdatedAt && env.UpdatedAt !== '0001-01-01T00:00:00Z' ? new Date(env.UpdatedAt).toLocaleString() : '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
